import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import RenderError from "utils/helper/RenderError";

const propTypes = {
  src: PropTypes.any.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

const Image = (props) => {
  let { src, alt, className, style } = props;
  const ref = useRef(null);
  const [hasError, setHasError] = useState("");

  PropTypes.checkPropTypes(propTypes, props, "props", "Image", () => {
    setHasError(true);
  });

  if (hasError) {
    return <RenderError component={"Image"} />;
  }

  return (
    <>
      <img ref={ref} src={src} alt={alt} className={className} style={style} />
    </>
  );
};

Image.propTypes = propTypes;

export default Image;
